module["exports"] = [
  "Sig.",
  "Dott.",
  "Dr.",
  "Ing."
];
